export default __webpack_public_path__ + "static/media/l21.84e5442e.png";